import Middleware from '../middleware';
const { flow } = Middleware;

export class Sandbox {
  constructor(ctx) {
    this.ctx = ctx;
    this.enabled = this.ctx.app.$client.profile.fake;
    this.notification = null;

    this.listen();
  }

  isCallable() {
    const { $auth, $cookies } = this.ctx.app;
    return Boolean($auth.isAdmin || $cookies.get('qa-disable-flow'));
  }

  async start() {
    const { default: mock } = await import('./mock.js');
    mock(this.ctx);
    this.enabled = true;
  }

  listen() {
    this.ctx.app.router.afterEach(() => {
      if (process.browser && this.enabled && !this.notification) {
        this.notification = this.ctx.app.$toast.show(
          "You are running sandbox mode, don't trust your eyes",
          {
            duration: 0,
            position: 'top-center',
            action: [
              {
                text: 'Hide',
                onClick: () => {
                  this.notification.remove();
                },
              },
              {
                text: 'Disable',
                onClick: () => {
                  this.ctx.app.$cookies.remove('qa-disable-flow');
                  this.notification.remove();
                  window.location.reload();
                },
              },
            ],
          }
        );
      }
    });
  }
}

export default (ctx, inject) => {
  const sandbox = new Sandbox(ctx);
  inject('sandbox', sandbox);

  Middleware.flow = async ctx => {
    if (sandbox.isCallable()) {
      await sandbox.start();
      return;
    }

    await flow(ctx);
  };
};
